var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUntick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(6985 -5354)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-6984 5355)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "checked",
    d: "M0,73.426,7.56,81,22.077,66.5l-2.084-2.055L7.56,76.862l-5.5-5.5Z",
    transform: "translate(-6974 5303.557)",
    fill: "#d9d9d9"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUntick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/untick.f9e3fee2.svg";
export { ForwardRef as ReactComponent };